// extracted by mini-css-extract-plugin
module.exports = {"optionTitle":"OptionLabel_optionTitle__3A4ai","optionSecondary":"OptionLabel_optionSecondary__x2rHp","sideLabel":"OptionLabel_sideLabel__2mGg4"};